import styled from 'styled-components';

export const Picture = styled.picture`
  display: contents;
`;
